import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, rState: RouterStateSnapshot): Observable<boolean> {
    return this.authService.authState$.pipe(map(state => {
          if (state !== null) { return true; }
          this.router.navigate(['/login']);
          return false;
        }
        )
    );
  }

}
